import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Google Analytics page view tracker
 * Tracks page views when route changes
 */
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if gtag is available and GA is configured
    if (typeof window.gtag === 'function') {
      const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
      
      if (measurementId && measurementId.startsWith('G-')) {
        window.gtag('config', measurementId, {
          page_path: location.pathname + location.search,
          page_title: document.title
        });
      }
    }
  }, [location]);
};

/**
 * Track custom events in Google Analytics
 * @param {string} eventName - Name of the event
 * @param {object} params - Event parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }
};

/**
 * Common events to track
 */
export const AnalyticsEvents = {
  // User actions
  SIGNUP_STARTED: 'signup_started',
  SIGNUP_COMPLETED: 'signup_completed',
  LOGIN: 'login',
  LOGOUT: 'logout',
  
  // Lead actions
  SERVICE_REQUEST_STARTED: 'service_request_started',
  SERVICE_REQUEST_SUBMITTED: 'service_request_submitted',
  
  // Contractor actions
  PROFILE_VIEWED: 'profile_viewed',
  CONTACT_CLICKED: 'contact_clicked',
  QUOTE_REQUESTED: 'quote_requested',
  
  // Job board actions
  JOB_POSTED: 'job_posted',
  JOB_APPLICATION_SUBMITTED: 'job_application_submitted',
  
  // Chat actions
  CHAT_OPENED: 'chat_opened',
  MESSAGE_SENT: 'message_sent',
  
  // Map actions
  MAP_VIEW_OPENED: 'map_view_opened',
  CONTRACTOR_MARKER_CLICKED: 'contractor_marker_clicked'
};

export default usePageTracking;
